import React from 'react';
import { etiquetaTipoCuenta, pieTipoCuenta } from './legalLabels';

function TenantTypeSelector({ tenantTypes, selectedType, onSelect }) {
  return (
    <div className="legal-tipo">
      <h2>Selecciona tu tipo de cuenta</h2>
      <p className="legal-tipo-intro">Esta selección determina qué documentos firmarás.</p>

      {tenantTypes.length === 0 ? null : (
        <div className="legal-tipo-grid" role="radiogroup" aria-label="Tipo de cuenta">
          {tenantTypes.map((type) => {
            const selected = selectedType === type.code;
            return (
              <button
                key={type.code}
                type="button"
                role="radio"
                aria-checked={selected}
                className={`legal-tipo-card${selected ? ' is-selected' : ''}`}
                onClick={() => onSelect(type.code)}
              >
                <span className="legal-tipo-check" aria-hidden="true">{selected ? '✓' : ''}</span>
                <strong>{etiquetaTipoCuenta(type.code)}</strong>
                <span className="legal-tipo-pie">{pieTipoCuenta(type.code)}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default TenantTypeSelector;
